import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ElementLanding from './pages/ElementLanding';
import Cart from './pages/Cart';
import About from './pages/About';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import PaymentFailed from './pages/PaymentFailed';
import OrderHistory from './pages/OrderHistory';
import OrderDetails from './pages/OrderDetails';
import EditProfile from './pages/EditProfile';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
// Policy pages
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
// Support pages
import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs';
import HelpSupport from './pages/HelpSupport';
// AI / Quiz pages
import Quiz from './pages/Quiz';
import QuizResult from './pages/QuizResult';
import ChatWidget from './components/ChatWidget';
// Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminOrders from './pages/admin/AdminOrders';
import AdminCustomers from './pages/admin/AdminCustomers';
import AdminFinance from './pages/admin/AdminFinance';
import AdminReconciliation from './pages/admin/AdminReconciliation';
import AdminEmailsWhitelist from './pages/admin/AdminEmailsWhitelist';
import AdminUsers from './pages/admin/AdminUsers';
import AdminReconciliationMonitor from './pages/admin/AdminReconciliationMonitor';
import AdminReconciliationMonitorV2 from './pages/admin/AdminReconciliationMonitorV2';
import Receipt from './pages/Receipt';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-primaryBg text-bodyText font-sans pt-20 md:pt-24">
        <Navbar />
        
        {/* Feature 12: ChatWidget — only render if OPENAI_API_KEY is configured */}
        {process.env.REACT_APP_ENABLE_AI_CHAT === 'true' && <ChatWidget />}

        <div className="flex-grow">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/element/:element" element={<ElementLanding />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/quiz/result" element={<QuizResult />} />

            {/* Public purchase routes — guests allowed */}
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />

            {/* Protected Routes */}
            <Route
              path="/order-confirmation/:orderId"
              element={
                <ProtectedRoute>
                  <OrderConfirmation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-failed"
              element={
                <ProtectedRoute>
                  <PaymentFailed />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute>
                  <OrderHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders/:orderId"
              element={
                <ProtectedRoute>
                  <OrderDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders/:id/receipt"
              element={
                <ProtectedRoute>
                  <Receipt />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/edit"
              element={
                <ProtectedRoute>
                  <EditProfile />
                </ProtectedRoute>
              }
            />

            {/* Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/products"
              element={
                <ProtectedRoute adminOnly>
                  <AdminProducts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/orders"
              element={
                <ProtectedRoute adminOnly>
                  <AdminOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/customers"
              element={
                <ProtectedRoute adminOnly>
                  <AdminCustomers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/finance"
              element={
                <ProtectedRoute adminOnly>
                  <AdminFinance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reconciliation"
              element={
                <ProtectedRoute adminOnly>
                  <AdminReconciliation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/emails"
              element={
                <ProtectedRoute adminOnly>
                  <AdminEmailsWhitelist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute adminOnly>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/shipments"
              element={
                <ProtectedRoute adminOnly>
                  <AdminReconciliationMonitor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reconciliation-monitor"
              element={
                <ProtectedRoute adminOnly>
                  <AdminReconciliationMonitorV2 />
                </ProtectedRoute>
              }
            />

            {/* 404 - Must be last */}
            <Route path="*" element={<NotFound />} />

            {/* Policy Routes */}
            <Route path="/terms"    element={<TermsOfService />} />
            <Route path="/privacy"  element={<PrivacyPolicy />} />
            <Route path="/returns"  element={<ReturnPolicy />} />
            <Route path="/shipping" element={<ShippingPolicy />} />

            {/* Support Routes */}
            <Route path="/faq"     element={<FAQ />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/help"    element={<HelpSupport />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
